import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import { Publish } from "@material-ui/icons"
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import Checkbox from "../../components/Checkbox/Checkbox"
import Address from "../../components/Address/Address"
// Data
import { createUser } from "../../redux/apiCalls"
// Styles
import { Container, Wrapper, Main, Title, StyledForm, FormItem, StyledLabel, StyledInput, StyledSelect, StyledOption, StyledButton } from "./NewUser.styles"
import { Upload, CreateImage, UploadIcon, ButtonContainer, ButtonWrapper, Message } from "./NewUser.styles"

const NewUser = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [errorMessage, setErrorMessage] = useState("")
    const [userInputs, setUserInputs] = useState({})
    const [deliveryAddress, setDeliveryAddress] = useState({
        name: "",
        street: "",
        zipCode: "",
        city: "",
        region: "",
        country: "",
        info: ""
    })
    const [invoiceAddress, setInvoiceAddress] = useState({
        name: "",
        street: "",
        zipCode: "",
        city: "",
        region: "",
        country: "",
        info: ""
    })

    useEffect(() => {
        setUserInputs((prev) => {
            return { ...prev, "deliveryAddress": deliveryAddress, "invoiceAddress": invoiceAddress }
        })
    }, [deliveryAddress, invoiceAddress])

    const [isAdmin, setIsAdmin] = useState(false)
    const isAdminChange = () => {
        setUserInputs(prev => {
            return { ...prev, "isAdmin": !isAdmin }
        })
        setIsAdmin((current) => !current)
    }

    const [active, setActive] = useState(true)
    const activeChange = () => {
        setUserInputs(prev => {
            return { ...prev, "active": !active }
        })
        setActive((current) => !current)
    }

    const [emailing, setEmailing] = useState(false)
    const emailingChange = () => {
        setUserInputs(prev => {
            return { ...prev, "emailing": !emailing }
        })
        setEmailing((current) => !current)
    }

    const [sms, setSms] = useState(false)
    const smsChange = () => {
        setUserInputs(prev => {
            return { ...prev, "sms": !sms }
        })
        setSms((current) => !current)
    }

    const handleChange = (e) => {
        setUserInputs((prev) => {
            return { ...prev, [e.target.name]: e.target.value }
        })
    }

    const handleImage = (e) => {
        const storage = getStorage(app)
        const fileName = "user_" + userInputs.username
        const storageRef = ref(storage, fileName)
        const uploadTask = uploadBytesResumable(storageRef, e.target.files[0])

        uploadTask.on('state_changed',
            (snapshot) => {
                const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                console.log('Upload is ' + progress + '% done')
                switch (snapshot.state) {
                    case 'paused':
                        console.log('Upload is paused')
                        break
                    case 'running':
                        console.log('Upload is running')
                        break
                    default:
                }
            },
            (error) => {
                console.log(error)
            },
            () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                    console.log('File available at', downloadURL)
                    setUserInputs((prev) => {
                        return { ...prev, "img": downloadURL }
                    })
                })
            }
        )
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        const res = await createUser(userInputs, dispatch)
        if (res === "success") {
            navigate("/users")
        } else {
            setErrorMessage(JSON.stringify(res))
        }
    }

    return (
        <>
            <Topbar />
            <Container>
                <Wrapper>
                    <Sidebar />
                </Wrapper>
                <Main>
                    <Title>New User</Title>
                    <StyledForm>
                        <FormItem>
                            <StyledLabel>Username</StyledLabel>
                            <StyledInput type="text" name="username" placeholder="john" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>First Name</StyledLabel>
                            <StyledInput type="text" name="firstName" placeholder="John" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Last Name</StyledLabel>
                            <StyledInput type="text" name="lastName" placeholder="Smith" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Type</StyledLabel>
                            <StyledSelect name="type" id="type" onChange={handleChange}>
                                <StyledOption value="public">Public</StyledOption>
                                <StyledOption value="distributor">Distributor</StyledOption>
                                <StyledOption value="optician">Optician</StyledOption>
                            </StyledSelect>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Email</StyledLabel>
                            <StyledInput type="text" name="email" placeholder="john@gmail.com" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Password</StyledLabel>
                            <StyledInput type="password" name="password" placeholder="password" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>
                                <Checkbox checked={isAdmin} onChange={isAdminChange} />
                                Admin
                            </StyledLabel>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>
                                <Checkbox checked={active} onChange={activeChange} />
                                Active
                            </StyledLabel>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Customer number</StyledLabel>
                            <StyledInput type="text" name="code" placeholder="1234" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Discount (%)</StyledLabel>
                            <StyledInput type="number" name="discount" placeholder="0" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>
                                <Checkbox checked={emailing} onChange={emailingChange} />
                                Emailing
                            </StyledLabel>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>
                                <Checkbox checked={sms} onChange={smsChange} />
                                SMS
                            </StyledLabel>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Language</StyledLabel>
                            <StyledSelect name="language" id="language" onChange={handleChange}>
                                <StyledOption value="en">English</StyledOption>
                                <StyledOption value="fr">French</StyledOption>
                            </StyledSelect>
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Phone</StyledLabel>
                            <StyledInput type="text" name="phone" placeholder="123 456 789" onChange={handleChange} />
                        </FormItem>
                        <FormItem>
                            <StyledLabel>Company name</StyledLabel>
                            <StyledInput type="text" name="companyName" placeholder="OPTIQUE TOTO" onChange={handleChange} />
                        </FormItem>
                        <Address role="delivery" setAddress={setDeliveryAddress} />
                        <Address role="invoice" setAddress={setInvoiceAddress} />
                        <Upload>
                            <CreateImage src={userInputs.img || "http://localhost:3000/images/no_avatar.jpg"} />
                            <StyledLabel htmlFor={"files"}>
                                <UploadIcon><Publish /></UploadIcon>
                            </StyledLabel>
                            <StyledInput type="file" id="files" name="files" style={{ display: "none" }} multiple onChange={handleImage} />
                        </Upload>
                    </StyledForm>
                    <ButtonContainer>
                        <ButtonWrapper>
                            <StyledButton onClick={handleSubmit}>Create</StyledButton>
                            <Message>{errorMessage}</Message>
                        </ButtonWrapper>
                    </ButtonContainer>
                </Main>
            </Container>
        </>
    )
}

export default NewUser